import { IAnyMap, IPaneModelKey, IStoreResizableItemsModel } from '../@types'
import { DIRECTIONS, RESIZER, SIZE } from './constant'
import { PaneModel } from '../models'

export type INoop = (_: any) => any

export const noop: INoop = (_: any): any => _

export const findById = <T>(list: T[] | any[], _id: string) =>
  list.find(({ id }) => id === _id)

// export const isUndefinedOrNull = (value: any) => value === undefined || value === null

export const findIndex = (list: any[], value: any, key = 'id') =>
  list.findIndex((item) => item[key] === value)

export const ratioToNumber = (totalSize: number, maxRatioValue: number, size: number) =>
  Number((totalSize * (size / maxRatioValue)).toFixed(0))

export const ratioAndRoundOff = (totalSize: number, maxRatioValue: number, size: number) => Math.round(
  ratioToNumber(totalSize, maxRatioValue, size)
)

export const filterKeys = <T>(obj: T, ...keys: (keyof T)[]) => {
  const retObj: any = {}
  keys.forEach(key => {
    retObj[key] = obj[key]
  })

  return retObj
}

export const isItUp = (direction: number) => direction === DIRECTIONS.UP
export const isItDown = (direction: number) => direction === DIRECTIONS.DOWN

export const getResizerId = (paneId: string) => `${RESIZER}-${paneId}`

// need to make pure
export const deleteUndefined = (anyObject: any) => {
  Object.keys(anyObject).forEach(key => {
    if (anyObject[key] === undefined) {
      delete anyObject[key]
    }
  })
  return anyObject
}

export const reverse = <T>(list: T[]): T[] => [...list].reverse()
export const filterEmpty = (list: any[]) => list.filter(_ => _)

export const sortNumber = (list: number[]) => {
  return [...list].sort((a, b) => {
    if (a > b) {
      return -1
    } else if (b > a) {
      return 1
    }
    return 0
  })
}
